document.documentElement.classList.remove('no-js');

const menuButton = document.querySelector('[data-menu-toggle]');
const menu = document.querySelector('[data-mobile-menu]');

if (menuButton && menu) {
  menuButton.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') === 'true';
    menuButton.setAttribute('aria-expanded', String(!open));
    menu.hidden = open;
    menu.classList.toggle('nav-open', !open);
    document.body.classList.toggle('menu-open', !open);
  });
}

document.querySelectorAll('[data-quantity-button]').forEach((button) => {
  button.addEventListener('click', () => {
    const input = button.parentElement.querySelector('input');
    if (!input) return;
    const delta = button.dataset.quantityButton === 'plus' ? 1 : -1;
    input.value = Math.max(Number(input.min || 0), Number(input.value || 0) + delta);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
});

function initVariantSelectors(root = document) {
  const mediaColorCache = new Map();

  const knownOpaqueMediaOrder = {
    'kento-nanami-the-end-of-duty-tee': 'black',
    'naruto-uzumaki-final-battle-with-pain-tee': 'white',
    'sasuke-uchiha-five-kage-summit-tee': 'black',
    'toji-s-final-stand-oversized-tee': 'white',
  };

  const inferBlackOrWhiteFromFilename = (value) => {
    const filename = String(value || '')
      .toLowerCase()
      .split('?')[0]
      .replace(/\.[a-z0-9]+$/i, '');

    const printedOnGarment = filename.match(/on[\s_-]*(black|white)(?=$|[\s_.-])/i);
    if (printedOnGarment) return printedOnGarment[1];

    const blankView = filename.match(/(black|white)[\s_-]*(front|back)(?=$|[\s_.-])/i);
    if (blankView) return blankView[1];

    const trailingColor = filename.match(/(black|white)(?=$|[\s_.-])/i);
    return trailingColor ? trailingColor[1] : null;
  };

  const detectBlackOrWhite = (media) => {
    const probeSrc = media.dataset.probeSrc || media.dataset.imageSrc;
    if (!probeSrc) return Promise.resolve(null);
    if (mediaColorCache.has(probeSrc)) return mediaColorCache.get(probeSrc);

    const detection = new Promise((resolve) => {
      const probe = new Image();
      probe.decoding = 'async';

      probe.addEventListener('load', () => {
        try {
          const canvas = document.createElement('canvas');
          const size = 80;
          canvas.width = size;
          canvas.height = size;
          const context = canvas.getContext('2d', { willReadFrequently: true });
          if (!context) {
            resolve(null);
            return;
          }

          context.drawImage(probe, 0, 0, size, size);
          const pixels = context.getImageData(0, 0, size, size).data;
          let luminanceTotal = 0;
          let sampledPixels = 0;

          // The lower middle of apparel mockups is normally blank shirt fabric,
          // making it a stable place to distinguish a white blank from a black one.
          for (let y = 48; y < 75; y += 1) {
            for (let x = 27; x < 53; x += 1) {
              const offset = ((y * size) + x) * 4;
              if (pixels[offset + 3] < 80) continue;
              const red = pixels[offset];
              const green = pixels[offset + 1];
              const blue = pixels[offset + 2];
              luminanceTotal += (0.2126 * red) + (0.7152 * green) + (0.0722 * blue);
              sampledPixels += 1;
            }
          }

          if (!sampledPixels) {
            resolve(null);
            return;
          }

          resolve((luminanceTotal / sampledPixels) >= 145 ? 'white' : 'black');
        } catch (error) {
          resolve(null);
        }
      }, { once: true });

      probe.addEventListener('error', () => resolve(null), { once: true });
      probe.src = probeSrc;
    });

    mediaColorCache.set(probeSrc, detection);
    return detection;
  };

  root.querySelectorAll('[data-variant-select]').forEach((select) => {
    if (select.dataset.variantReady === 'true') return;
    select.dataset.variantReady = 'true';

    const normalizeMediaKey = (value) => String(value || '')
      .toLowerCase()
      .replace(/[\s_-]+/g, '');

    const updateVariant = async (updateUrl = false) => {
      const option = select.options[select.selectedIndex];
      const selectedVariantId = option.value;
      const section = select.closest('[data-product-section]') || document;
      const price = section.querySelector('[data-product-price]');
      const image = section.querySelector('[data-product-image]');
      const addToCart = section.querySelector('[data-add-to-cart]');
      const colorKey = normalizeMediaKey(option.dataset.color);
      const mediaItems = Array.from(section.querySelectorAll('[data-product-media-key]'));
      let colorMedia = null;

      if (colorKey === 'white' || colorKey === 'black') {
        colorMedia = mediaItems.find((item) => (
          inferBlackOrWhiteFromFilename(item.dataset.productMediaFilename) === colorKey
        ));
      } else if (colorKey) {
        colorMedia = mediaItems.find((item) => (
          normalizeMediaKey(item.dataset.productMediaKey).includes(colorKey)
        ));
      }

      if (!colorMedia && (colorKey === 'white' || colorKey === 'black')) {
        const firstMediaColor = knownOpaqueMediaOrder[section.dataset.productHandle];
        if (firstMediaColor && mediaItems.length >= 2) {
          const groupSize = Math.max(1, Math.floor(mediaItems.length / 2));
          colorMedia = colorKey === firstMediaColor ? mediaItems[0] : mediaItems[groupSize];
        }
      }

      if (!colorMedia && (colorKey === 'white' || colorKey === 'black')) {
        const detectedColors = await Promise.all(mediaItems.map((item) => detectBlackOrWhite(item)));
        const detectedIndex = detectedColors.findIndex((detectedColor) => detectedColor === colorKey);
        if (detectedIndex >= 0) colorMedia = mediaItems[detectedIndex];
      }

      // Ignore a slow image-analysis result if the shopper selected another variant.
      if (select.value !== selectedVariantId) return;

      const media = colorMedia?.dataset || option.dataset;

      if (price && option.dataset.price) price.textContent = option.dataset.price;

      if (image && media.imageSrc) {
        image.src = media.imageSrc;
        if (media.imageSrcset) image.srcset = media.imageSrcset;
        if (media.imageWidth) image.width = Number(media.imageWidth);
        if (media.imageHeight) image.height = Number(media.imageHeight);
        image.alt = media.imageAlt || '';
      }

      if (addToCart) {
        const available = option.dataset.available === 'true';
        addToCart.disabled = !available;
      }

      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      }
    };

    select.addEventListener('change', () => updateVariant(true));
    updateVariant();
  });
}

initVariantSelectors();
document.addEventListener('shopify:section:load', (event) => initVariantSelectors(event.target));

function initVideoCarousels(root = document) {
  root.querySelectorAll('[data-video-carousel]').forEach((carousel) => {
    if (carousel.dataset.carouselReady === 'true') return;

    const slides = Array.from(carousel.querySelectorAll('[data-video-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-video-dot]'));
    const previous = carousel.querySelector('[data-video-prev]');
    const next = carousel.querySelector('[data-video-next]');
    let current = 0;

    if (!slides.length) return;
    carousel.dataset.carouselReady = 'true';

    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === current;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
        if (!active) {
          slide.querySelectorAll('video').forEach((video) => video.pause());
        }
      });
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === current;
        dot.classList.toggle('is-active', active);
        dot.classList.toggle('active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    };

    previous?.addEventListener('click', () => show(current - 1));
    next?.addEventListener('click', () => show(current + 1));
    dots.forEach((dot, index) => dot.addEventListener('click', () => show(index)));
    show(0);
  });
}

initVideoCarousels();
document.addEventListener('shopify:section:load', (event) => initVideoCarousels(event.target));

function initExactFilters(root = document) {
  root.querySelectorAll('[data-exact-filter-toggle]').forEach((button) => {
    if (button.dataset.filterReady === 'true') return;
    const section = button.closest('.catalog');
    const panel = section?.querySelector('[data-exact-filter-panel]');
    if (!panel) return;
    button.dataset.filterReady = 'true';
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      button.classList.toggle('active', !open);
      panel.classList.toggle('filter-panel-open', !open);
    });
  });
}

initExactFilters();
document.addEventListener('shopify:section:load', (event) => initExactFilters(event.target));

function initCollectionProductFilters(root = document) {
  root.querySelectorAll('[data-filter-grid]').forEach((section) => {
    if (section.dataset.collectionFilterReady === 'true') return;

    const cards = Array.from(section.querySelectorAll('[data-grid-card]'));
    const buttons = Array.from(section.querySelectorAll('[data-grid-filter]'));
    const count = section.querySelector('[data-filter-count]');
    const empty = section.querySelector('[data-filter-empty]');

    if (!buttons.length) return;
    section.dataset.collectionFilterReady = 'true';

    const applyFilter = (selectedButton) => {
      const selected = selectedButton.dataset.gridFilter || 'all';
      let visible = 0;

      buttons.forEach((button) => button.classList.toggle('active', button === selectedButton));
      cards.forEach((card) => {
        const values = (card.dataset.filterValues || '').trim().split(/\s+/).filter(Boolean);
        const show = selected === 'all' || values.includes(selected);
        card.hidden = !show;
        if (show) visible += 1;
      });

      if (count) count.textContent = String(visible);
      if (empty) empty.hidden = visible !== 0;
    };

    buttons.forEach((button) => button.addEventListener('click', () => applyFilter(button)));
    applyFilter(buttons.find((button) => button.classList.contains('active')) || buttons[0]);
  });
}

initCollectionProductFilters();
document.addEventListener('shopify:section:load', (event) => initCollectionProductFilters(event.target));
